import styled, { css } from 'styled-components'

import { fontWeight, fontFamily, color } from '../../styles'

import { fontSize } from 'src/styles/fonts'

interface WrapProps {
  color: string
  wtfispp?: boolean
  city?: boolean
}

export const Wrap = styled.button<WrapProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(p) => (p.wtfispp ? '29.5rem' : '100%')};
  height: 5.6rem;
  border-radius: 2.8rem;
  background-color: ${(p) => p.color};

  p {
    font-size: ${fontSize.NORMAL};
    font-family: ${fontFamily.CATAMARAN};
    font-weight: ${fontWeight.BOLD};
    line-height: 1.5;
    text-align: center;
    color: ${color.WHITE};
  }

  :disabled {
    opacity: 0.3;
  }

  ${(p) =>
    !p.city &&
    css`
      svg {
        margin-right: 1.4rem;
    `}
`
